/**
 * Health check types and utilities
 * Step 7: Device capability checks and health reporting
 * V1.1: Added device profile for smart routing
 */
/**
 * Check WebGPU availability and get adapter info.
 * Never throws - returns health info even on failure.
 */
export async function checkWebGPU() {
    // Check if navigator.gpu exists
    if (typeof navigator === 'undefined' || !navigator.gpu) {
        return {
            supported: false,
            error: 'WebGPU API not available (navigator.gpu is undefined)',
        };
    }
    try {
        const adapter = await navigator.gpu.requestAdapter();
        if (!adapter) {
            return {
                supported: false,
                error: 'No WebGPU adapter available',
            };
        }
        // Get adapter info
        const info = adapter.info;
        const adapterInfo = {};
        if (info) {
            if (info.vendor)
                adapterInfo.vendor = info.vendor;
            if (info.architecture)
                adapterInfo.architecture = info.architecture;
            if (info.description)
                adapterInfo.description = info.description;
        }
        return {
            supported: true,
            adapterInfo: Object.keys(adapterInfo).length > 0 ? adapterInfo : undefined,
        };
    }
    catch (error) {
        return {
            supported: false,
            error: error instanceof Error ? error.message : String(error),
        };
    }
}
//# sourceMappingURL=health.js.map